const APPLE_APP_STORE_URL = 'https://apps.apple.com/us/app/id942371609';
const GOOGLE_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=prepublic.fupa';

export {APPLE_APP_STORE_URL, GOOGLE_PLAY_STORE_URL};
